import React from 'react';
import { connect } from 'react-redux';
import AppWrapper from '../app_wrapper/AppWrapper';
import { apiGet } from '../modules/api';
import ProductListMobile from '../components_mobile/pages/ProductList';
import ProductListDesktop from '../components_desktop/pages/ProductList';
import { designerMode } from '../helpers/productListModes';
import { brandsUrl } from '../helpers/routes';
import metadata from '../helpers/metadataHelper';

const DesignerComponent = props => {
  const allProps = { mode: designerMode, ...props };
  return (
    <AppWrapper
      desktopComp={<ProductListDesktop {...allProps} />}
      mobileComp={<ProductListMobile {...allProps} />}
      metadata={metadata.designer}
    />
  );
};

DesignerComponent.getInitialProps = ({ store, req, res }) => {
  // avoid req undefined on back button
  if (!req) {
    return;
  }
  const {
    params: { brandName, brandId, departmentName },
    query
  } = req;

  const department = departmentName ? `/${departmentName.toLowerCase()}` : '';
  return store.dispatch(
    apiGet(
      `api/brands/${brandName}/${brandId}${department}`,
      req,
      res,
      {
        params: query
      },
      () => {
        const prefix = req.params && req.params.countryCode ? `/${req.params.countryCode}` : '';
        return res.redirect(`${prefix}${brandsUrl}`);
      }
    )
  );
};

const mapStateToProps = ({
  api: {
    filterSettings,
    fbPixelSearchDetailData,
    brandDescription,
    brandName,
    closeSizeGuide,
    currencySymbol,
    categoryName,
    categoryPath,
    categoryUrl,
    freeShipping,
    onSale,
    openSizeGuide,
    products,
    page,
    sizes,
    query,
    s3BasePath,
    sizeGuideVisibility,
    total
  }
}) => ({
  filterSettings,
  fbPixelSearchDetailData,
  brandDescription,
  brandName,
  closeSizeGuide,
  currencySymbol,
  categoryName,
  categoryPath,
  categoryUrl,
  freeShipping,
  onSale,
  openSizeGuide,
  page,
  products,
  sizes,
  query,
  s3BasePath,
  sizeGuideVisibility,
  total
});

export default connect(mapStateToProps)(DesignerComponent);
